// extracted by mini-css-extract-plugin
export default {"dueDate":"dueDate_dueDate__q0fUl","overdue":"dueDate_overdue__RGJ2a","complete":"dueDate_complete__wXvwJ","bold":"dueDate_bold__ph6a+","left":"dueDate_left__l5Q82"};